import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "trigger"]

  connect() {
    // Close dropdown when clicking outside
    this.handleClickOutside = this.handleClickOutside.bind(this)
    document.addEventListener("click", this.handleClickOutside)
    
    // Close dropdown when clicking on menu items
    if (this.hasMenuTarget) {
      this.menuTarget.addEventListener("click", this.handleMenuClick.bind(this))
    }
  }

  disconnect() {
    document.removeEventListener("click", this.handleClickOutside)
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()
    
    // Close all other open dropdowns first
    document.querySelectorAll("[data-controller='dropdown'].show").forEach(el => {
      if (el !== this.element) {
        el.classList.remove("show")
        el.dataset.dropdownOpen = "false"
      }
    })
    
    const isOpen = this.element.classList.toggle("show")
    // Also set data attribute for CSS-based visibility (used in desktop menubar)
    this.element.dataset.dropdownOpen = isOpen ? "true" : "false"
    
    // Position the dropdown menu if it uses fixed positioning
    if (isOpen && this.hasMenuTarget) {
      this.positionMenu(event.currentTarget)
    }
  }
  
  positionMenu(trigger) {
    const menu = this.menuTarget
    const triggerRect = trigger.getBoundingClientRect()
    
    // Position below the trigger
    menu.style.top = `${triggerRect.bottom + 4}px`
    menu.style.left = `${triggerRect.left}px`
    
    // Ensure menu doesn't go off-screen to the right
    requestAnimationFrame(() => {
      const menuRect = menu.getBoundingClientRect()
      if (menuRect.right > window.innerWidth) {
        menu.style.left = `${window.innerWidth - menuRect.width - 8}px`
      }
    })
  }

  handleClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }

  handleMenuClick(event) {
    // Close dropdown when clicking on any link or button inside the menu
    const clickedItem = event.target.closest("a, button")
    if (clickedItem) {
      this.close()
    }
  }

  close() {
    this.element.classList.remove("show")
    this.element.dataset.dropdownOpen = "false"
  }
}
